export default "String val1 = a != null ? \"yes\" : \"no\";\nString val2 = a != null ? ( b != null ? \"yes\" : \"no\") : \"maybe\";\n"